import Configs from "../config";
import { ContactNote } from "../types/NoteTypes";
import { getVisitorId } from "../utils/FingerPrint";
import { localStorageGetItem } from "../utils/LocalStorage";
import { FindAllContactWithFilterIRoute } from "./Contacts";

async function getNotesFromContact(
  contactId: string
): Promise<ContactNote[] | false> {
  const token = localStorageGetItem("USER_TOKEN");
  const response: Response = await fetch(
    `${Configs.SERVER_URL}/note/contact/${contactId}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );

  if (response.ok) {
    const responseObj = await response.json();
    return responseObj.data;
  } else {
    return false;
  }
}

async function createUserNote(body: {
  noteCategoryId: string;
  note: string;
  contactId: string;
}): Promise<ContactNote | false> {
  const userUid = localStorageGetItem("USER_UID");
  const token = localStorageGetItem("USER_TOKEN");
  const visitorId = await getVisitorId();
  const response: Response = await fetch(
    `${Configs.SERVER_URL}/note/userNote`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        "X-Visitor-Id": visitorId,
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({ ...body, userUid }),
    }
  );

  if (response.ok) {
    const responseObj = await response.json();
    return responseObj.data;
  } else {
    return false;
  }
}

async function createUserNoteOnContactsSelected(body: {
  noteCategoryId: string;
  note: string;
  contactIds?: string[];
  query?: FindAllContactWithFilterIRoute;
}): Promise<ContactNote | false> {
  const userUid = localStorageGetItem("USER_UID");
  const token = localStorageGetItem("USER_TOKEN");
  const visitorId = await getVisitorId();
  const response: Response = await fetch(
    `${Configs.SERVER_URL}/note/userNote/contacts-selected`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        "X-Visitor-Id": visitorId,
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({ ...body, userUid }),
    }
  );

  if (response.ok) {
    const responseObj = await response.json();
    return responseObj.data;
  } else {
    return false;
  }
}

export const NoteAPI = {
  getNotesFromContact,
  createUserNote,
  createUserNoteOnContactsSelected,
};
